import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { PageTransition, PageContent } from './PageTransition';

/**
 * Layout Component - Main application layout wrapper
 */
const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const savedCollapsed = localStorage.getItem('sidebarCollapsed');
    if (savedCollapsed !== null) {
      setSidebarCollapsed(JSON.parse(savedCollapsed));
    }
  }, []);

  const handleToggleCollapse = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    localStorage.setItem('sidebarCollapsed', JSON.stringify(newState));
  };

  const getPageTitle = () => {
    const routes = {
      '/rentalbiz/dashboard': 'Dashboard',
      '/rentalbiz/properties': 'Propiedades',
      '/rentalbiz/properties/new': 'Nueva Propiedad',
      '/rentalbiz/contracts': 'Contratos',
      '/rentalbiz/contracts/new': 'Nuevo Contrato',
      '/rentalbiz/payments': 'Pagos',
      '/rentalbiz/certificados': 'Cuentas de cobro',
      '/rentalbiz/configuracion': 'Configuracion',
      '/material-calculator': 'Material Calculator',
      '/material-calculator/projects': 'Proyectos',
      '/material-calculator/rulesets': 'Reglas y parametros',
      '/material-calculator/catalog': 'Catalogo de materiales',
      '/material-calculator/settings': 'Configuracion',
      '/rentaltech/dashboard': 'RentalTech Dashboard',
      '/rentaltech/equipments': 'Equipos',
      '/rentaltech/customers': 'Clientes',
      '/rentaltech/availability': 'Disponibilidad',
      '/rentaltech/orders': 'Arrendamientos',
      '/rentaltech/maintenance': 'Mantenimiento',
      '/rentaltech/telemetry': 'Telemetria',
      '/rentaltech/billing': 'Facturacion LATAM',
      '/rentaltech/mobile-ops': 'Mobile Ops',
      '/brain-emprendedor/dashboard': 'BrainEmprendedor',
      '/admin': 'Administracion',
      '/dashboard': 'Dashboard'
    };

    if (location.pathname.startsWith('/material-calculator')) return 'Material Calculator';
    if (location.pathname.startsWith('/agendalab')) return 'AgendaLab';
    if (location.pathname.startsWith('/rentaltech')) return 'RentalTech LATAM';
    if (location.pathname.startsWith('/brain-emprendedor')) return 'BrainEmprendedor LATAM';
    if (location.pathname.startsWith('/admin')) return 'Administracion';

    return routes[location.pathname] || 'AppEmprendedor - RentalBiz';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapse={handleToggleCollapse}
      />

      <div className={`transition-all duration-300 ease-in-out ${sidebarCollapsed ? 'lg:pl-20' : 'lg:pl-64'}`}>
        <Header
          onMenuClick={() => setSidebarOpen(true)}
          sidebarCollapsed={sidebarCollapsed}
          pageTitle={getPageTitle()}
        />

        <PageContent>
          <PageTransition animation="fade">
            <Outlet />
          </PageTransition>
        </PageContent>
      </div>
    </div>
  );
};

export default Layout;
